export const text = {
  downloadableMemories: "Downloadable Memories",
  memoryPara: "Sharing a life legacy for generations to come.",
  imageVideo: "Image & Video",
  audio: "Audio",
  pdf: "PDF",
  viewPdf: "View PDF",
  download: "Download",
  craftingMoment: "Crafting Moments, One Theme at a Time",
  capturedMemories: "Captured Memories",
  heartfeltReflection: " Heartfelt Reflection",
  timelineOfMeaningfulMemories: "Highlights of a Life Well Lived",
  about: "ABOUT",
  birthPlace: "Birth Place",
  spouse: "Spouse",
  parents: "Parents",
  children: "Children",
  siblings: "Siblings",
  born: "Born",
  memorialPlaces: "Memorial Places",
  visitedCountries: "visited countries",
  gallery: "Gallery",
  familyTree: "Family Tree",
  timeline: "Timeline",
  clickImage: "Click an image to view a timeless memory",
  timeLessMemories: "Lifetime Journey",
  photographs: "Photographs- Videos- Other Media",
  captureMemory: "Captured Memories",
  memoriesOf: "Memories of",
  pendingComments: "Pending Comments",
  shareStory: "Share A Story",
  shareBio: "Share Biography",
  shareLink: "Share this link via",
  copyUrl: "Copy Url",
  copyLink: "Copy Link",
  copied: "Copied",
  chronicleLife: "Chronicles of a Life",
  timeLine: "Highlights of a Life Well Lived",
  viewPDf: "View PDF",
  whereEachChapter:
    "Where each chapter unfolds a unique tale of growth, resilience, and self-discovery.",
  writeComment: "Write Comment",
  reportBio: "Report Biography",
  biography: "Biography",
  category: "Category",
  story: 'Story',
  heartFelt: 'Heartfelt Reflections',
  downloadableMemoriesText: "Digital Keepsakes to Preserve and Share a Life Well Lived.",
};
